import React from 'react';
import { Icon } from './Icon.js';
export const IconChevronMinimizeDiagonal2Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m4.75,5.5H.75c-.414,0-.75-.336-.75-.75s.336-.75.75-.75h3.25V.75c0-.414.336-.75.75-.75s.75.336.75.75v4c0,.414-.336.75-.75.75Z", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("path", { d: "m7.25,12c-.414,0-.75-.336-.75-.75v-4c0-.414.336-.75.75-.75h4c.414,0,.75.336.75.75s-.336.75-.75.75h-3.25v3.25c0,.414-.336.75-.75.75Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" })));
};
//# sourceMappingURL=IconChevronMinimizeDiagonal2Fill12.js.map